/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedAddressList
 */
export interface PaginatedAddressList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedAddressList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedAddressList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedAddressList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Address>}
     * @memberof PaginatedAddressList
     */
    results?: Array<Address>;
}

export function PaginatedAddressListFromJSON(json: any): PaginatedAddressList {
    return PaginatedAddressListFromJSONTyped(json, false);
}

export function PaginatedAddressListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedAddressList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(AddressFromJSON)),
    };
}

export function PaginatedAddressListToJSON(value?: PaginatedAddressList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(AddressToJSON)),
    };
}


